import { get } from 'lodash-es';

import { Controller, useFormContext } from 'react-hook-form';
import { FormFeedback, FormGroup } from './common';
import { RichTextEditor } from '../index';

interface RichTextEditorProps<TKeys extends string> {
  name: string;
  translate: (key: TKeys) => string;
  value?: string;
  onChange?: (value: string) => void;
  defaultValue?: string;
  helperText?: string;
  readOnly?: boolean;
}

const FormRichTextEditor = <TKeys extends string>({
  translate,
  value,
  onChange,
  defaultValue,
  helperText,
  readOnly = false,
  ...props
}: RichTextEditorProps<TKeys>) => {
  const methods = useFormContext();
  const errorMessage = get(methods.formState.errors, [
    ...props.name.split('.'),
    'message',
  ]) as TKeys;
  if (value !== undefined && onChange !== undefined) {
    // is controlled
    return (
      <FormGroup>
        <RichTextEditor
          {...{ readOnly, name: props.name }}
          value={value}
          onChange={(value) => onChange(value)}
        />
        {errorMessage ? (
          <FormFeedback invalid>{translate(errorMessage)}</FormFeedback>
        ) : helperText ? (
          <FormFeedback>{helperText}</FormFeedback>
        ) : null}
      </FormGroup>
    );
  }
  return (
    <FormGroup>
      <Controller
        defaultValue={defaultValue || ''}
        control={methods.control}
        name={props.name}
        render={({ field }) => (
          <RichTextEditor
            {...{ readOnly, name: props.name }}
            value={field.value}
            onChange={(value) => field.onChange(value)}
          />
        )}
      />
      {errorMessage ? (
        <FormFeedback invalid>{translate(errorMessage)}</FormFeedback>
      ) : helperText ? (
        <FormFeedback>{helperText}</FormFeedback>
      ) : null}
    </FormGroup>
  );
};

export default FormRichTextEditor;
